import { AppJoyride } from "@/shared/ui/AppJoyride";
import { userFormTourSteps } from "./formTourSteps";

type UserFormTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function UserFormTour({ run, onCallback }: UserFormTourProps) {
  return (
    <AppJoyride steps={userFormTourSteps} run={run} onCallback={onCallback} />
  );
}

export { useUserFormTour } from "./useUserFormTour";
